import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * CanonicalUrl component
 * - Sets canonical link for current page
 * - Prevents duplicate content issues in SEO
 */
export const CanonicalUrl = () => {
  const location = useLocation();
  const baseUrl = "https://complyhub.ai";

  useEffect(() => {
    // Get the canonical URL (lowercase, no trailing slash except root)
    const path = location.pathname.toLowerCase().replace(/\/$/, "") || "/";
    const canonicalUrl = `${baseUrl}${path}`;

    // Find or create canonical link element
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    
    canonicalLink.setAttribute("href", canonicalUrl);

    return () => {
      // Cleanup not needed as we reuse the same element
    };
  }, [location.pathname]);

  return null;
};

export default CanonicalUrl;
